module.exports = __webpack_public_path__ + "img/AMAZON.780eaff0.png";